import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { IGlobalState } from "../../interfaces/vendors/global.interface"

const initialState: IGlobalState = {
    loading: false,
    pageTitle: "",
    tenantName: "",
    tenantLogo: "",
    tenantLogoHash: ""
}

export const globalSlice = createSlice({
    name: "global",
    initialState,
    reducers: {
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload
        },
        setPageTitle: (state, action: PayloadAction<string>) => {
            state.pageTitle = action.payload
        },
        setTenantName: (state, action: PayloadAction<string>) => {
            state.tenantName = action.payload
        },
        setTenantLogo: (state, action: PayloadAction<string>) => {
            state.tenantLogo = action.payload
        },
        setTenantLogoHash: (state, action: PayloadAction<string>) => {
            state.tenantLogoHash = action.payload
        }
    }
})

export const { setLoading, setPageTitle, setTenantName, setTenantLogo, setTenantLogoHash } = globalSlice.actions
export default globalSlice.reducer;